<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('autoinformer.campaign.filter.name.title') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.search" :clearable="true" />
        </div>
      </div>
      <select-status v-model="form.active" class="col-3" />
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('autoinformer.campaign.filter.caller_id.title') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.caller" type="number" :clearable="true" />
        </div>
      </div>
    </div>
    <div class="filter__row">
      <div class="col-4 filter__item filter__item--datepicker">
        <label class="filter__item__title">
          {{ $t('shared.component.filter.period') }}
        </label>
        <div class="filter__item__body">
          <date-range-picker v-model="form.date" />
        </div>
      </div>
      <div class="filter__item filter__item--button">
        <i-button html-type="submit" type="primary">
          {{ $t('shared.component.filter.show_result') }}
        </i-button>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import SelectStatus from './campaigns-filter-status';
  import FilterWrapper from '@shared/components/filter-base';
  import { mapActions } from 'vuex';
  import { parseSearchStateByPeriod } from '@shared/helpers/date_format';

  export default {
    components: {
      FilterWrapper,

      SelectStatus
    },
    data: () => ({
      numbers: [],
      form: {
        search: null,
        caller: null,
        date: {
          start: null,
          end: null
        },
        pbx_number_id: null
      }
    }),
    computed: {
      is_pbx_allow: function () {
        return this.$permission.module_pbx_is_allowed;
      }
    },

    created() {
      this.submit();
    },

    methods: {
      ...mapActions('autoinformer/campaigns/table', ['search']),

      submit: function () {
        const { start, end } = parseSearchStateByPeriod(this.form.date);
        const { search = '', active, pbx_number_id, caller } = this.form;

        const params = {
          name: search,
          start,
          end,
          active,
          pbx_number_id,
          caller
        };

        this.search(params);
      }
    }
  };
</script>
